import {view} from '@sail/ui';

import {ScreenContentLayout} from 'src/fund/components/screen/ScreenContentLayout';

export const NetworkSelectScreen = () => (
  <ScreenContentLayout>
    <view.div data-testid="network-select-screen">Select network</view.div>
  </ScreenContentLayout>
);
